export enum StorageKeys {
  Token = 'token',
  RefreshToken = 'refreshToken',
  CodeName = 'codeName',
  EnterType = 'enterType',
  MainBotName = 'mainBotName',
  Locale = 'locale',
  Theme = 'theme',
  OpenPages = 'openpages',
  EventListMode = 'eventListMode',
  LpProductListMode = 'lpProductListMode',
  City = 'city',
  FirstLoyaltyLogin = 'firstLoyaltyLogin',
  FirstDeviceLogin = 'firstDeviceLogin',
}
